<template>
  <div class="wrapper" style="overflow: auto">
    <!-- alerta -->
    <v-snackbar top v-model="snackbar" :color="snackbarColor" multi-line>
      {{ snackbarText }}
      <v-btn dark icon text @click="snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

    <div class="register-card">
      <div class="back">
        <v-btn icon small @click="goBack()">
          <v-icon class="white--text text--darken-1">arrow_back</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      </div>
      <div class="register-card-header">
        <img
          :src="require(`@/assets/logos/usecargobranco.png`)"
          alt="pickndrive"
          style="width: 240px; margin-bottom: 12%; margin-top: 5%"
        />
      </div>

      <div class="text-center pb-3">
        <span class="title font-weight-bold white--text text--darken-1"
          >Cadastro</span
        >
      </div>
      <form @submit.prevent="cadastro()">
        <div class="form-group text-center">
          <label for="cep-input">CEP *</label>
          <input
            v-mask="'##.###-###'"
            type="text"
            class="form-control"
            v-model="cep"
            id="cep-input"
            placeholder="xx.xxx-xxx"
            required
            v-on:blur="obterCondominioPorCep()"
            minlength="8"
          />
        </div>
        <div class="form-group text-center">
          <label for="client-input">Origem *</label>
          <v-tooltip bottom max-width="200">
            <template v-slot:activator="{ on }">
              <v-icon
                aria-hidden="true"
                small
                color="#9fd7f8"
                v-on="on"
                class="ml-2"
                >help</v-icon
              >
            </template>
            <span
              >Se o seu condomínio não está presente na lista, procure a sua
              administração.</span
            >
          </v-tooltip>
          <v-select
            :items="clients"
            v-model="clientSelected"
            :required="!clientSelected"
            item-text="name"
            item-value="id"
            label="Informe o cep antes da Origem"
            id="client-input"
            class="select-client"
            color="success"
            no-data-text="Nenhuma origem cadastrada"
            hide-details
            solo
            text
          ></v-select>
        </div>
        <div class="form-group text-center">
          <label for="name-input">Nome *</label>
          <input
            type="text"
            class="form-control"
            v-model="name"
            id="nome-input"
            placeholder="Nome Completo"
            required
          />
        </div>
        <div class="form-group text-center">
          <label for="email-input">E-mail *</label>
          <input
            type="email"
            class="form-control"
            v-model="email"
            id="email-input"
            aria-describedby="emailHelp"
            placeholder="seuemail@host.com.br"
            required
          />
        </div>
        <div class="form-group text-center">
          <label for="email-input">Endereço *</label>
          <input
            type="text"
            class="form-control"
            v-model="endereco"
            id="endereco-input"
            aria-describedby="enderecoHelp"
            placeholder="Seu endereço"
            required
          />
        </div>
        <div class="form-group text-center">
          <label>Comprovante de residência</label>
          <v-tooltip bottom max-width="200">
            <template v-slot:activator="{ on }">
              <v-icon
                aria-hidden="true"
                small
                color="info"
                v-on="on"
                class="ml-2"
                >help</v-icon
              >
            </template>
            <span>
              O Comprovante de residência não é obrigatório, mas agiliza o
              processo de aprovação do seu cadastrado.
              <br />Documentos aceitos: Água, Luz e Telefone
            </span>
          </v-tooltip>
          <div class="custom-file">
            <input
              type="file"
              class="custom-file-input"
              @change="changeArchive('proof_of_address')"
            />
            <label class="custom-file-label">Anexar arquivo</label>
          </div>
        </div>
        <div class="px-2">
          <v-radio-group v-model="situacao" mandatory row>
            <v-radio color="white" value="Morador">
              <template v-slot:label>
                <div class="white--text pt-2">Morador</div>
              </template>
            </v-radio>
            <v-radio color="white" value="Locatario">
              <template v-slot:label>
                <div class="white--text pt-2">Locatário</div>
              </template>
            </v-radio>
          </v-radio-group>
        </div>
        <div class="form-group text-center">
          <label for="cpf-input">CPF *</label>
          <input
            v-mask="'###.###.###-##'"
            type="text"
            class="form-control"
            v-model="cpf"
            id="cpf-input"
            placeholder="xxx.xxx.xxx-xx"
            required
            minlength="11"
          />
        </div>
        <div class="form-group text-center">
          <label for="cnh-input">CNH</label>
          <input
            v-mask="'###########'"
            type="text"
            class="form-control"
            v-model="cnh"
            id="cnh-input"
            placeholder="xxxxxxxxxxx"
          />
        </div>
        <div class="form-group text-center">
          <label for="telefone-input">Telefone *</label>
          <input
            v-mask="'(##)#####-####'"
            type="text"
            class="form-control"
            v-model="telefone"
            id="telefone-input"
            placeholder="(DDD)Número"
            required
          />
        </div>

        <div class="form-group text-center">
          <label for="nascimento-input">Data de Nascimento</label>
          <input
            v-mask="'##/##/####'"
            type="text"
            class="form-control"
            v-model="dataNascimento"
            id="nascimento-input"
            placeholder="xx/xx/xxxx"
          />
        </div>

        <div class="form-group text-center">
          <label for="invitation-code-input">Código de Indicação</label>
          <input
            :disabled="invitation_code_disabled"
            type="text"
            class="form-control"
            v-model="invitation_code"
            id="invitation-code-input"
          />
        </div>

        <div class="form-group text-center">
          <label for="password-input">Senha *</label>
          <div class="input-group mb-3">
            <input
              :type="UI.passwordInputType"
              v-model="password"
              id="password-input"
              class="form-control"
              placeholder="Senha do usuário"
              aria-label="Senha do usuário"
              aria-describedby="basic-addon2"
              required
            />
            <div class="input-group-append">
              <span
                class="input-group-text change-visibility-span"
                id="basic-addon2"
                @click="showPassword"
                >{{ UI.passwordInputButton }}</span
              >
            </div>
          </div>
          <div class="mb-3">
            <input
              type="password"
              class="form-control"
              v-model="passwordCheck"
              id="password-input-check"
              placeholder="Confirme sua senha"
              required
            />
          </div>
        </div>

        <button
          :disabled="UI.isLoggingIn"
          type="submit"
          class="btn btn-block mt-5 white--text"
        >
          {{ UI.isLoggingIn ? 'Carregando' : 'CADASTRE-SE' }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import AuthController from '../../controllers/AuthController.js';
import ClientController from '../../controllers/ClientController.js';
import UserController from '../../controllers/UserController';

export default {
  data() {
    return {
      clientController: new ClientController(this.$resource),
      userController: new UserController(this.$resource),
      name: null,
      email: null,
      password: null,
      endereco: null,
      situacao: null,
      cpf: null,
      telefone: null,
      dataNascimento: null,
      cnh: null,
      cep: null,
      passwordCheck: null,
      clients: [],
      clientSelected: null,
      invitation_code: this.$route.params.codigo,
      invitation_code_disabled: false,
      UI: {
        isLoggingIn: false,
        passwordInputType: 'password',
        passwordInputButton: 'Mostrar',
      },
      snackbar: false,
      snackbarColor: '',
      snackbarText: '',
      files: [],
    };
  },

  created() {
    if (this.invitation_code != null) {
      this.invitation_code_disabled = true;
    }
    this.authController = new AuthController(
      this.$resource,
      this.$router,
      this.$message
    );
  },

  methods: {
    async getClients() {
      await this.clientController
        .getAllClientsPublic()
        .then(clients => (this.clients = clients));
    },

    goBack() {
      this.$router.push('/');
    },

    goToApp() {
      window.location.href = 'https://usecargo.page.link/rniX';
    },

    validate() {
      if (this.password != this.passwordCheck) throw 'As senhas não coincidem.';
      if (!this.clientSelected) throw 'Selecione uma origem';
    },

    showPassword() {
      let type = this.UI.passwordInputType;

      if (type === 'password') {
        this.UI.passwordInputType = 'text';
        this.UI.passwordInputButton = 'Esconder';
        return;
      }

      this.UI.passwordInputButton = 'Mostrar';
      this.UI.passwordInputType = 'password';
    },

    async obterCondominioPorCep() {
      if (this.cep.length != 10) {
        this.clients = [];
        this.$awn.alert('CEP inválido!');
        return;
      }

      await this.clientController
        .getClientsByZipcode(this.cep)
        .then(clients => (this.clients = clients));
    },

    alert(text, color) {
      this.snackbarText = text;
      this.snackbarColor = color;
      this.snackbar = true;
    },

    changeArchive(type) {
      this.files.push({
        type,
        data: event.target.files[0],
      });
    },

    cadastro() {
      try {
        this.validate();

        let data = new FormData();

        let form = {
          name: this.name,
          email: this.email,
          password: this.password,
          clientsUser: this.clientSelected,
          situacao: this.situacao,
          endereco: this.endereco,
          hasForPasswordChange: false,
          profile_id: 2,
          cpf: this.cpf,
          phone: this.telefone,
          birthday: new Date('this.dataNascimento'),
          drive_license: this.cnh,
          invitation_code: this.invitation_code,
        };

        data.append('form', JSON.stringify(form));

        this.files.forEach(element => {
          data.append(element.type, element.data);
        });

        this.userController
          .publicCreate(data)
          .then(res => {
            this.alert('Cadastro efetuado!', 'success');
            this.alert(
              'Aguarde a aprovação do seu cadastrado, pelo administrador do sistema.!',
              'success'
            );
            this.goToApp();
          })
          .catch(e => {
            if (e.body.message) this.alert(e.body.message, 'error');
            else
              this.alert(
                'Erro ao realizar cadastro, verifique seus dados e tente novamente.',
                'error'
              );
          });
      } catch (error) {
        this.alert(error, 'error');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.title {
  color: var(--primary-color);
}

.select-client {
  border: solid 1px rgb(204, 204, 204) !important;
}

a:hover {
  cursor: pointer;
}

.wrapper {
  position: fixed;
  width: 100vw;
  height: 100%;
  background: url('../../assets/background-register.png');
  z-index: 2;
  background-size: cover;
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  // justify-content: center;
  align-items: center;
  @media (max-width: 560px) {
    overflow: scroll;
    padding-bottom: 150px;
  }
}

input {
  border: 1px solid #ccc;
}

.input-group-append .input-group-text.change-visibility-span {
  background: white;
  border: 1px solid #ccc;
}

.wrapper .register-card {
  border-radius: 3px;
  width: 350px;
  position: relative;
  @media (max-width: 600px) {
    width: 80%;
  }
}

.register-card label {
  color: white;
}

.register-card .change-visibility-span:hover {
  cursor: pointer;
}

.register-card .register-card-header {
  display: flex;
  justify-content: center;
  img {
    width: 150px;
    height: 100%;
  }
}

footer,
footer p {
  margin-top: 20px;
  color: #979797;
  max-width: 400px;
  font-size: 9px;
  @media (max-width: 560px) {
    width: 80%;
  }
}

label {
  font-weight: bold;
  color: white;
}

.btn {
  background: var(--primary-color);
  font-weight: bold;
  &:disabled {
    background: rgba(100, 100, 100, 1);
    opacity: 1;
    color: white;
  }
}

input[type='checkbox'].form-control {
  width: fit-content;
  margin-right: 10px;
}

.back {
  display: flex;
  position: absolute;
  top: 10px;
}

a {
  color: rgb(159, 215, 248);
}
</style>
